import { useNavigate } from "react-router-dom";
import { componentWithCondition } from "../../newLayout/page/components/hoc/componentWithConditionCheck";

const TaxCategoryAction = () => {
  const navigate = useNavigate();

  const redirectTaxCategoryMapping = () => navigate("/master/tax_category/mapping");
  return (
    <>
      <li className="tableButton activeState">
        <button onClick={redirectTaxCategoryMapping}>Tax Category Mapping</button>
      </li>
    </>
  );
};

export const TaxCategoryActionWithCheck = componentWithCondition(TaxCategoryAction);
